import { types } from "../action-types";

const initialState = {
  loading: false,
  albums: [],
  error: false,
};

const fetchAlbumsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_EMP_ALBUMS_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_EMP_ALBUMS_SUCCESS:
      return {
        ...state,
        loading: false,
        albums: action.payload,
        error: false,
      };
    case types.GET_EMP_ALBUMS_FAILURE:
      return {
        ...state,
        loading: false,
        albums: [],
        error: true,
      };
    default:
      return state;
  }
};

export default fetchAlbumsReducer;
